import "whatwg-fetch";

import { getUserId } from "../../functions/auth";
import { doRequest, prepareInternalRequest } from "../../functions/api";

/*
 * Action types
 */

export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";

/*
 * Action creators
 */

/**
 * An action creator for requesting all orders for the current user.
 *
 * @returns {Object} An Orders requests is being sent action.
 */
export function getOrdersRequest() {
	return {
		type: GET_ORDERS_REQUEST,
	};
}

/**
 * An action creator for the retrieval of the orders.
 * @param {Object} json The json object
 * @returns {Object} An Orders retrieved action.
 */
export function getOrdersSuccess( json ) {
	return {
		type: GET_ORDERS_SUCCESS,
		orders: json,
	};
}

/**
 * An action creator for the server request action.
 *
 * @param {object} error The error that was thrown.
 *
 * @returns {Object} A server request action.
 */
export function getOrdersFailure( error ) {
	return {
		type: GET_ORDERS_FAILURE,
		error: error,
	};
}

/**
 * An action creator for retrieving all orders for the current user.
 *
 * @returns {Object} A order retrieval dispatcher.
 */
export function getOrders() {
	return ( dispatch ) => {
		dispatch( getOrdersRequest() );

		const userId = getUserId();
		const request = prepareInternalRequest( `Customers/${ userId }/orders/`, "GET", {}, { queryParams: { filter: { include: "lineItems" } } } );

		return doRequest( request )
			.then( json => dispatch( getOrdersSuccess( json ) ) )
			.catch( ( error ) => {
				dispatch( getOrdersFailure( error ) );
			} );
	};
}
